var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAvdSearch = function SvgAvdSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.333H4.167v29.334h25.666v-22H22.5V4.333ZM.5 2.485C.5 1.481 1.32.667 2.332.667h22.001L33.5 9.833v25.654a1.835 1.835 0 0 1-1.82 1.846H2.32A1.833 1.833 0 0 1 .5 35.515V2.485Zm19.303 21a7.337 7.337 0 0 1-8.91-11.503 7.333 7.333 0 0 1 11.502 8.91l4.052 4.052-2.592 2.594-4.052-4.052v-.002Zm-1.133-3.726a3.666 3.666 0 1 0-5.094-5.274 3.666 3.666 0 0 0 5.094 5.274Z",
    fill: "#000"
  })));
};

export default SvgAvdSearch;